import React, {useState} from 'react';
import Modal from '../../../../../shared/components/modal';
import Label from '../../../../../shared/components/label';
import FormikTextInput from '../../../../components/inputs/formik-text-input';
import styles from './endpoint-styles.module.scss';
import {Form, Formik} from 'formik';
import Button from '../../../../components/button';
import classnames from 'classnames';
import {endpointConfigurationSchema, generatePassword} from './integration-utils';
import {errorMessage, flashMessage} from '../../../../../shared/actions/notifications';
import {useDispatch} from 'react-redux';
import EndpointConfigurationService, {
  EndpointConfiguration,
} from '../../../../services/EndpointConfigurationService';
import {PasswordDisplay} from './password-display';

interface Props {
  onClose: () => void;
  initialValues: EndpointConfiguration;
  updateEndpointConfigurations: (endpointConfiguration: EndpointConfiguration) => void;
  universityId: string;
}

export const EndpointConfigurationModal = ({
  onClose,
  initialValues,
  universityId,
  updateEndpointConfigurations,
}: Props) => {
  const dispatch = useDispatch();
  const [newlyGeneratedPassword, setNewlyGeneratedPassword] = useState('');

  const isEdit = !!initialValues.id;

  const handleSubmit = async (values: EndpointConfiguration): Promise<void> => {
    const data = {
      ...values,
      universityId: universityId,
    };

    try {
      const endpointConfiguration = await EndpointConfigurationService.createOrUpdate(data, {
        universityId: universityId,
      });
      updateEndpointConfigurations(endpointConfiguration);
      dispatch(flashMessage(`Your endpoint has been ${isEdit ? 'updated' : 'created'}`));
    } catch (err) {
      dispatch(errorMessage('Oops! Something went wrong with saving your endpoint!'));
      console.error(err);
    } finally {
      onClose();
    }
  };

  const testEndpoint = () => {
    alert('Hi todd - how on earth are we going to test an andpoint fr?');
  };

  return (
    <Modal show onClose={onClose}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={endpointConfigurationSchema(isEdit)}
        validateOnMount
      >
        {({isSubmitting, isValid, values, setFieldValue}) => (
          <Form className={styles.editCollegeProfile}>
            <Modal.TextHeader onClose={onClose}>
              {isEdit ? 'Edit' : 'Add'} Endpoint
            </Modal.TextHeader>
            <Modal.Body className={styles.endPointModalBody}>
              <Label required>
                Endpoint URL
                <FormikTextInput name="url" placeholder="Endpoint URL" />
              </Label>
              <Label required>
                Authentication Method
                <FormikTextInput
                  name="authenticationMethod"
                  placeholder="Basic Authentication"
                  required
                  disabled
                />
              </Label>
              <Label required>
                Username
                <FormikTextInput name="username" placeholder="Username" required />
              </Label>
              <p className={classnames(styles.marginTopBig, 'shared-font bold')}>Password *</p>
              <PasswordDisplay
                isEdit={isEdit}
                generatedPassword={newlyGeneratedPassword}
                formPassword={values.password}
              />
              <FormikTextInput type="hidden" name="password" />
              <div className={styles.marginTopFifteen}>
                <Button
                  color="primary"
                  margin={false}
                  size="medium"
                  className={styles.floatRight}
                  onClick={() => {
                    const newPassword = generatePassword();
                    setFieldValue('password', newPassword);
                    setNewlyGeneratedPassword(newPassword);
                  }}
                >
                  Generate New Password
                </Button>
              </div>
              <div className={styles.marginTopFifteen}>
                <Button
                  color="primary"
                  size="medium"
                  onClick={testEndpoint}
                  className={styles.floatRight}
                >
                  Test Endpoint
                </Button>
              </div>
            </Modal.Body>
            <Modal.Footer
              primaryButton={{
                text: isSubmitting ? 'Saving...' : 'Save',
                type: 'submit',
                disabled: isSubmitting || !isValid,
              }}
              secondaryButton={{text: 'Cancel', onClick: onClose}}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
